import { intersect, partial, string, struct } from 'io-ts/Decoder';

import { Id } from './Id';

export const RefItem = intersect(
	struct({
		id: Id,
	})
)(
	partial({
		name: string,
	})
);
